import React, { useEffect, useContext } from 'react';
import { ISuccessfulAuth } from '../../../interfaces';
import { appleLogin } from '../../../stores/auth.store';
import { MainContext } from '../../../context/main.context';
import { APPLE_ID_AUTH_SIGN_IN_ERROR, LOGIN_BY_APPLE_ID_ERROR } from '../../../common/errorCodes';
import ManualController from '../../../hoc/ManualController';

const EXCEPTION_ERRORS: string[] = [ 'user_cancelled_authorize', 'popup_closed_by_user' ];


export default function AppleAuth() {
    const { modalContent, toggleLoader } = useContext(MainContext);
    const { manualRedirect } = ManualController();

    useEffect(() => {
        const script = document.createElement('script');
        script.src = process.env.REACT_APP_APPLE_SRC as string;
        script.async = true;
        script.onload = () => {
            window.AppleID.auth.init({
                clientId: process.env.REACT_APP_APPLE_CLIENT_ID,
                scope: 'name email',
                redirectURI: process.env.REACT_APP_APPLE_REDIRECT_URL,
                usePopup: true,
            });
        }

        document.body.appendChild(script);

        return () => {
            document.body.removeChild(script);
        };
    }, []);

    const _appleSignIn = (): void => {
        toggleLoader(true);

        window.AppleID.auth['signIn']().then((res: any): void => {
            const idToken: string = res?.authorization?.['id_token'] || '';

            _appleLogin(idToken);
        }, (err: any): void => {
            if (!EXCEPTION_ERRORS.includes(err.error)) {
                manualRedirect(err, 'auth', true, APPLE_ID_AUTH_SIGN_IN_ERROR);
            }
        }).finally(() => {
            toggleLoader(false);
        });
    }

    const _appleLogin = (idToken: string): void => {
        toggleLoader(true);

        appleLogin(idToken).then((res: { data: ISuccessfulAuth }) => {
            const result = res?.data?.result;

            if (result) {
                manualRedirect(result, 'auth');
                return;
            }
            manualRedirect(res, 'auth', true, LOGIN_BY_APPLE_ID_ERROR);
        }, err => {
            const errData = err?.response?.data || err;

            manualRedirect(errData, 'auth', true, LOGIN_BY_APPLE_ID_ERROR);
        }).finally(() => {
            toggleLoader(false);
        });
    }

    return (
        <div
            className="auth-id"
            data-mode="logo-only"
            data-color="white"
            data-border="false"
            data-border-radius="50"
            data-size="40"
            onClick={_appleSignIn}
        />
    );
}